// navLinks.js - Centralized navigation links
// Used by Navbar and Footer components

export const navLinks = [
    { to: "/", textKey: "nav.home", showInFooter: false },
    { to: "/nosotros", textKey: "nav.about", showInFooter: true },
    { to: "/servicios", textKey: "nav.services", showInFooter: true },
    { to: "/portafolio", textKey: "nav.portfolio", showInFooter: true },
    { to: "/blog", textKey: "nav.blog", showInFooter: false },
    { to: "/contacto", textKey: "nav.contact", showInFooter: true },
];

// Get links for navbar (all links except contact which is special button)
export const getNavbarLinks = () => navLinks.filter(link => link.to !== "/contacto");

// Get links for footer (only those marked for footer)
export const getFooterLinks = () => navLinks.filter(link => link.showInFooter);
